/**
 * CAAA1050：ログイン前情報取得API（入力項目）
 */
export default class CAAA1050RequestModel {
  id: number
}
